import React from "react"
import {CustomWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const CustomWrap = ({children}) => {
  return <CustomWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomWrapper>
}
export default CustomWrap



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomWrapper/index.js